import { useState, useEffect } from "react";

export default function useIsMobile(breakpoint = 1024) {
  const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

  const [isMobile, setIsMobile] = useState(mediaQuery.matches);

  useEffect(() => {
    const handleChange = (e) => setIsMobile(e.matches);

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [mediaQuery]);

  return isMobile;
}
